var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        ref: "pdfTemple",
        staticClass: "pdfTemple",
        staticStyle: {
          position: "absolute",
          bottom: "-9999px",
          width: "1920px",
        },
      },
      [
        _c("div", { staticClass: "title" }, [_vm._v("WareHouse Recpit Check")]),
        _c(
          "div",
          {
            staticClass: "flex-align flex-spacebetween",
            staticStyle: {
              "border-bottom": "2px solid #ccc",
              "margin-bottom": "10px",
            },
          },
          [
            _c("div", [
              _c("div", { staticClass: "form-item flex-align" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("Document Date:"),
                ]),
                _c("div", { staticClass: "form-value" }, [
                  _vm._v(_vm._s(_vm.data.auditTime)),
                ]),
              ]),
              _c("div", { staticClass: "form-item flex-align" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("Purchase Order No.:"),
                ]),
                _c("div", { staticClass: "form-value" }, [
                  _vm._v(_vm._s(_vm.data.code)),
                ]),
              ]),
              _c("div", { staticClass: "form-item flex-align" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("Supllier ID:"),
                ]),
                _c("div", { staticClass: "form-value" }, [
                  _vm._v(_vm._s(_vm.data.supplierCode)),
                ]),
              ]),
            ]),
            _c("img", {
              staticStyle: { width: "160px", height: "80px" },
              attrs: { src: _vm.$getPublicImage("sello.jpg") },
            }),
            _vm._m(0),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "flex-align flex-spacebetween",
            staticStyle: { margin: "20px 0" },
          },
          [
            _c("div", { staticClass: "flex" }, [
              _c("div", { staticClass: "form-item" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("Suplier Information:"),
                ]),
                _c("div", { staticClass: "form-value" }, [
                  _vm._v(_vm._s(_vm.data.supplierName)),
                ]),
              ]),
              _vm._m(1),
            ]),
            _c("div", [
              _c("div", { staticClass: "form-item flex-align" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-label",
                    staticStyle: { width: "100px" },
                  },
                  [_vm._v("Order Date:")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "form-value",
                    staticStyle: { width: "160px" },
                  },
                  [_vm._v(_vm._s(_vm.data.creationDate))]
                ),
              ]),
              _c("div", { staticClass: "form-item flex-align" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-label",
                    staticStyle: { width: "100px" },
                  },
                  [_vm._v("reference:")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "form-value",
                    staticStyle: { width: "160px" },
                  },
                  [_vm._v(_vm._s(_vm.data.vendorRefNo))]
                ),
              ]),
            ]),
          ]
        ),
        _c(
          "el-table",
          { staticClass: "emptyItem", attrs: { data: _vm.data.goodsList } },
          [
            _c("el-table-column", {
              attrs: { label: "Item", prop: "skuCode", align: "center" },
            }),
            _c("el-table-column", {
              attrs: { label: "Description", prop: "skuName", align: "center" },
            }),
            _c("el-table-column", {
              attrs: { label: "How many Ctn", prop: "aaa", align: "center" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Ctn Barcode",
                prop: "rpcGoodsResVO.cartonBoxBarcode",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Ctn Qty",
                prop: "rpcGoodsResVO.qty",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Ctn Length",
                prop: "rpcGoodsResVO.cartonLength",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Ctn Width",
                prop: "rpcGoodsResVO.cartonWidth",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Ctn Height",
                prop: "rpcGoodsResVO.cartonHeight",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Ctn Weight",
                prop: "rpcGoodsResVO.cartonWeight",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Unit Barcode",
                prop: "rpcGoodsResVO.barCode",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "Unit Qty", prop: "alreadyQty", align: "center" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Unit Length",
                prop: "rpcGoodsResVO.length",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Unit Width",
                prop: "rpcGoodsResVO.width",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Unit Height",
                prop: "rpcGoodsResVO.height",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Unit Weight",
                prop: "rpcGoodsResVO.weight",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "Remarks", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          scope.row.purchaseType == "COMMON"
                            ? ""
                            : _vm.data.remark
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._m(2),
      ],
      1
    ),
    _c(
      "div",
      {
        ref: "pdfTemple1",
        staticClass: "pdfTemple",
        staticStyle: { position: "absolute", top: "-9999px", width: "1920px" },
      },
      [
        _c("div", { staticClass: "title" }, [_vm._v("PURCHASE QUOTATAION")]),
        _c(
          "div",
          {
            staticClass: "flex-align flex-spacebetween",
            staticStyle: {
              "border-bottom": "2px solid #ccc",
              "margin-bottom": "10px",
            },
          },
          [
            _c("div", [
              _c("div", { staticClass: "form-item flex-align" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("Document Date:"),
                ]),
                _c("div", { staticClass: "form-value" }, [
                  _vm._v(_vm._s(_vm.data.auditTime)),
                ]),
              ]),
              _c("div", { staticClass: "form-item flex-align" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("Purchase Order No.:"),
                ]),
                _c("div", { staticClass: "form-value" }, [
                  _vm._v(_vm._s(_vm.data.code)),
                ]),
              ]),
              _c("div", { staticClass: "form-item flex-align" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("Supllier ID:"),
                ]),
                _c("div", { staticClass: "form-value" }, [
                  _vm._v(_vm._s(_vm.data.supplierCode)),
                ]),
              ]),
              _c("div", { staticClass: "form-item flex-align" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("Purchase Amt:"),
                ]),
                _c("div", { staticClass: "form-value" }, [
                  _vm._v(_vm._s(_vm.purchaseAmt)),
                ]),
              ]),
            ]),
            _c("img", {
              staticStyle: { width: "160px", height: "80px" },
              attrs: { src: _vm.$getPublicImage("sello.jpg") },
            }),
            _vm._m(3),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "flex-align flex-spacebetween",
            staticStyle: { margin: "20px 0" },
          },
          [
            _c("div", { staticClass: "flex" }, [
              _c("div", { staticClass: "form-item" }, [
                _c("div", { staticClass: "form-label" }, [
                  _vm._v("Suplier Information:"),
                ]),
                _c("div", { staticClass: "form-value" }, [
                  _vm._v(_vm._s(_vm.data.supplierName)),
                ]),
              ]),
              _vm._m(4),
            ]),
            _c("div", [
              _c("div", { staticClass: "form-item flex-align" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-label",
                    staticStyle: { width: "100px" },
                  },
                  [_vm._v("Order Date:")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "form-value",
                    staticStyle: { width: "160px" },
                  },
                  [_vm._v(_vm._s(_vm.data.creationDate))]
                ),
              ]),
              _c("div", { staticClass: "form-item flex-align" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-label",
                    staticStyle: { width: "100px" },
                  },
                  [_vm._v("Delivery By:")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "form-value",
                    staticStyle: { width: "160px" },
                  },
                  [_vm._v(_vm._s(_vm.data.finishTime))]
                ),
              ]),
              _c("div", { staticClass: "form-item flex-align" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-label",
                    staticStyle: { width: "100px" },
                  },
                  [_vm._v("Cancel Date:")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "form-value",
                    staticStyle: { width: "160px" },
                  },
                  [_vm._v(_vm._s(_vm.data.expectedDate))]
                ),
              ]),
            ]),
          ]
        ),
        _c(
          "el-table",
          { staticClass: "emptyItem", attrs: { data: _vm.data.goodsList } },
          [
            _c("el-table-column", {
              attrs: {
                label: "Item",
                prop: "rpcGoodsResVO.skuCode",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Description",
                prop: "rpcGoodsResVO.skuName",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Brand",
                prop: "rpcGoodsResVO.brandName",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Unit price",
                prop: "taxUnitPrice",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v("AUD " + _vm._s(scope.row.taxUnitPrice))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Quantity", prop: "planQty", align: "center" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Amount(AUD)",
                prop: "totalPrice",
                align: "center",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "flex-align flex-spacebetween",
            staticStyle: { "margin-top": "50px" },
          },
          [
            _c("div"),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "form-item flex-align",
                  staticStyle: {
                    "padding-top": "10px",
                    "border-top": "1px solid #000",
                  },
                },
                [
                  _c("div", { staticClass: "form-label" }, [
                    _vm._v("Carried Forward"),
                  ]),
                  _c("div", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.purchaseAmt)),
                  ]),
                ]
              ),
              _c("div", { staticClass: "form-item flex-align" }, [
                _c("div", { staticClass: "form-label" }, [_vm._v("Subtotal")]),
                _c("div", { staticClass: "form-value" }, [
                  _vm._v("AUD " + _vm._s(_vm.purchaseAmt)),
                ]),
              ]),
              _c("div", { staticClass: "form-item flex-align" }, [
                _c("div", { staticClass: "form-label" }, [_vm._v("Total Tax")]),
                _c("div", { staticClass: "form-value" }, [
                  _vm._v("AUD " + _vm._s(_vm.taxTotal || 0)),
                ]),
              ]),
              _c("div", { staticClass: "form-item flex-align" }, [
                _c("div", { staticClass: "form-label" }, [_vm._v("Total")]),
                _c("div", { staticClass: "form-value" }, [
                  _vm._v(
                    "AUD " +
                      _vm._s(
                        Number(_vm.purchaseAmt) + Number(_vm.taxTotal || 0)
                      )
                  ),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._m(5),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "form-item flex-align" }, [
        _c("div", { staticClass: "form-label" }, [
          _vm._v("Sello Products Pty Ltd"),
        ]),
      ]),
      _c("div", { staticClass: "form-item flex-align" }, [
        _c("div", { staticClass: "form-label" }, [_vm._v("7 Duigan Drive")]),
      ]),
      _c("div", { staticClass: "form-item flex-align" }, [
        _c("div", { staticClass: "form-label" }, [
          _vm._v("MOORABBIN AIRPORT VIC"),
        ]),
      ]),
      _c("div", { staticClass: "form-item flex-align" }, [
        _c("div", { staticClass: "form-label" }, [_vm._v("3194")]),
      ]),
      _c("div", { staticClass: "form-item flex-align" }, [
        _c("div", { staticClass: "form-label" }, [_vm._v("AUSTRALIA")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-item" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Ship To:")]),
      _c("div", { staticClass: "form-value" }, [
        _vm._v("Sello Products Pty Ltd"),
      ]),
      _c("div", { staticClass: "form-value" }, [_vm._v("7 Duigan Drive")]),
      _c("div", { staticClass: "form-value" }, [
        _vm._v("MOORABBIN AIRPORT VIC"),
      ]),
      _c("div", { staticClass: "form-value" }, [_vm._v("3194")]),
      _c("div", { staticClass: "form-value" }, [
        _vm._v("AUSTRALIA "),
        _c("b", { staticStyle: { "margin-left": "20px" } }, [
          _vm._v("Note: Please fill ctn details if it is more than one pice"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-column" }, [
      _c("div", { staticStyle: { margin: "20px 0" } }, [
        _c("b", [_vm._v("Name______________________________")]),
        _c("b", { staticStyle: { "margin-left": "5px" } }, [
          _vm._v("Date______________________________"),
        ]),
      ]),
      _c("b", [_vm._v("Signature______________________________")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "form-item flex-align" }, [
        _c("div", { staticClass: "form-label" }, [
          _vm._v("Sello Products Pty Ltd"),
        ]),
      ]),
      _c("div", { staticClass: "form-item flex-align" }, [
        _c("div", { staticClass: "form-label" }, [_vm._v("7 Duigan Drive")]),
      ]),
      _c("div", { staticClass: "form-item flex-align" }, [
        _c("div", { staticClass: "form-label" }, [
          _vm._v("MOORABBIN AIRPORT VIC"),
        ]),
      ]),
      _c("div", { staticClass: "form-item flex-align" }, [
        _c("div", { staticClass: "form-label" }, [_vm._v("3194")]),
      ]),
      _c("div", { staticClass: "form-item flex-align" }, [
        _c("div", { staticClass: "form-label" }, [_vm._v("AUSTRALIA")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-item" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Ship To:")]),
      _c("div", { staticClass: "form-value" }, [
        _vm._v("Sello Products Pty Ltd"),
      ]),
      _c("div", { staticClass: "form-value" }, [_vm._v("7 Duigan Drive")]),
      _c("div", { staticClass: "form-value" }, [
        _vm._v("MOORABBIN AIRPORT VIC"),
      ]),
      _c("div", { staticClass: "form-value" }, [_vm._v("3194")]),
      _c("div", { staticClass: "form-value" }, [_vm._v("AUSTRALIA")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-align" }, [
      _c("b", [_vm._v("Signature______________________________")]),
      _c("b", { staticStyle: { "margin-left": "5px" } }, [
        _vm._v("Date______________________________"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }